import { useTranslation } from "react-i18next";

export default function TextDiv({
  title,
  value,
  divClasses,
  pClasses,
  spanClasses,
}) {
  const { t } = useTranslation("general");

  return (
    <div className={divClasses}>
      <p className={`u-padding_0 u-margin_0 ${pClasses}`}>{t(title)}:</p>
      <span className={`${spanClasses} t-unicode-text t-bold_semi-bold`}>
        {value || "-"}
      </span>
    </div>
  );
}
